import React from "react"
import { useAppContainerContext } from "../appContainer/context"
import { useNavigate } from "react-router-dom"
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import IconButton from '@mui/joy/IconButton';
import Stack from '@mui/joy/Stack';
import Avatar from '@mui/joy/Avatar';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import ListDivider from '@mui/joy/ListDivider';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import NavigationDropdown from './headerNavigationDropdown';
import { useUserContext } from "../contextProviders/userContext"

export function HeaderBar(props) {
  const { title, header, progress, menuOptions } = useAppContainerContext()
  const { user, logout } = useUserContext()
  const navigate = useNavigate()

  function stringAvatar(name) {
    if (!name || typeof name !== 'string') {
      return {
        sx: {
          bgcolor: '#D8E6E5',
        },
        children: 'U',
      };
    }

    const nameParts = name.split(' ');
    const firstInitial = nameParts[0] ? nameParts[0][0] : '';
    const secondInitial = nameParts[1] ? nameParts[1][0] : '';

    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${firstInitial}${secondInitial}` || 'U',
    };
  }

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
  }

  return (
    <>
        <Box className="inner-header-bar" sx={{ display: 'flex', flexGrow: 1, justifyContent: 'space-between' }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
            
            }}
          >
            <IconButton className="header-logo-button"
              size="md"
              title="Home"
              color="neutral"
      
              onClick={() => navigate('/home')}
            >
              RECAAPP
            </IconButton>
            {user && (
              <Typography component="h1" sx={{ fontWeight: 'xl' }}>
                {title}
              </Typography>
            )}
          </Stack>

          {user && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 1.5,
                alignItems: 'center',
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', gap: 1.5, alignItems: 'center' }}>
                {/* Progress and Header elements moved here */}
                {progress && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {progress}
                  </Box>
                )}
                {header && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {header}
                  </Box>
                )}
              </div>
              <NavigationDropdown menuOptions={menuOptions} />
              <Dropdown>
                <MenuButton
                  variant="plain"
                  size="sm"
                  sx={{ maxWidth: '32px', maxHeight: '32px', borderRadius: '9999999px' }}
                >
                  <Avatar
                    variant="outlined"
                    size="sm"{...stringAvatar(user?.name)}
                  />
                </MenuButton>
                <Menu
                  placement="bottom-end"
                  size="sm"
                  sx={{
                    zIndex: '99999',
                    p: 1,
                    gap: 1,
                    '--ListItem-radius': 'var(--joy-radius-sm)',
                  }}
                >
                  <MenuItem disabled>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar
                        variant="outlined"
                        size="sm"{...stringAvatar(user?.name)}
                      />
                      <Box sx={{ ml: 1.5 }}>
                        <Typography level="title-sm" textColor="text.primary">
                          {user?.name || 'User'}
                        </Typography>
                        <Typography level="body-xs" textColor="text.tertiary">
                          {user?.email || ''}
                        </Typography>
                      </Box>
                    </Box>
                  </MenuItem>
                  {
                    user.role === 'admin' && (
                      <>
                        <ListDivider />
                        <MenuItem onClick={() => navigate('/admin')}>
                          <AdminPanelSettingsIcon />
                          Admin
                        </MenuItem>
                      </>
                    )
                  }
                  <ListDivider />
                  <MenuItem key={'Logout'} onClick={logout} >
                    <LogoutRoundedIcon />
                    Log out
                  </MenuItem>
                </Menu>
              </Dropdown>
            </Box>
          )}
        </Box>
    </>
  )
}